import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  RadialLinearScale,
  Title,
  Tooltip,
} from "chart.js";
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getSnapshotDetails } from "../../../app/api/trendSnapshot";
import { RootState } from "../../../app/store";
import { ReactComponent as LeftArrow } from "../../../assets/icons/leftArrow.svg";
import { LineGraphData, TrendItem } from "../../../interface/DesignerInterface";
import { getFactoredTrendCurveResponse } from "../../../utils/commonUtils";
import Dropdown from "../Dropdown";
import TrendTable from "../TrendsSidebar/TrendCurveTable";
import TrendCurvesGraph from "../TrendsSidebar/TrendCurvesGraph";

ChartJS.register(
  RadialLinearScale,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  ChartDataLabels,
  ChartDataLabels
);

interface ExpandViewTrendCurvesProps {
  isSidebarOpen?: boolean;
}

const ExpandViewSnapshotTrendCurveAnalysis: React.FC<
  ExpandViewTrendCurvesProps
> = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const [filterType, setFilterType] = useState("Most Popular");
  const [loading, setLoading] = useState(true);
  const dummyFilterType = ["Month on Month", "Week on Week"];

  type FilterType = (typeof dummyFilterType)[number];
  const mappedFilterType: Record<FilterType, string> = {
    "Most Popular": "most_popular",
    "New and Emerging": "new_and_emerging",
  };
  const [trendsCurveData, setTrendsCurveData] = useState<LineGraphData>({
    labels: [],
    datasets: [],
  });
  const [trendsCurveRawData, setTrendsCurveRawData] = useState<TrendItem[]>([]);

  const user = useSelector((state: RootState) => state.user.userInfo);
  const { id } = useParams();
  const numericSnapshotId = Number(id);
  const fetchDetails = async (page: number) => {
    const detailsParams = {
      page: page,
      numberOfTrends: 1,
      postsPerTrend: 1,
    };
    try {
      const snapDetails = await getSnapshotDetails(
        numericSnapshotId,
        user,
        detailsParams
      );
      const trendCurveResponse = snapDetails?.data.lineGraphData;
      setTrendsCurveRawData(trendCurveResponse);
      const factoredTrendCurveResponse =
        getFactoredTrendCurveResponse(trendCurveResponse);
      setTrendsCurveData(factoredTrendCurveResponse);
    } catch (error) {
      console.error("Error fetching snapshot details:", error);
    }
  };
  useEffect(() => {
    fetchDetails(1);
  }, []);
  return (
    <div
      className={`bg-white fixed h-[calc(100vh-80px)] ml-2 ${!isSidebarOpen ? "w-[calc(100vw-265px)]" : "w-[calc(100vw-105px)]"} transition-all duration-500 ease-in-out`}
    >
      <div className="flex flex-row justify-between mb-4">
        <div className="flex flex-row mt-6">
          <div>
            <LeftArrow
              className="text-lg ml-4 mt-4 cursor-pointer"
              onClick={() => navigate(`/trend-snapshot/details/${id}`)}
            />
          </div>
          <div className="transition-all  duration-500 ease-in-out opacity-100 font-semibold max-w-full ml-4 mt-2.5 text-secondary ">
            Trend Curves
          </div>
        </div>
        <div className="mt-2 mr-4">
          <div className="text-sm">Filter By</div>
          <div className="w-48">
            <Dropdown
              label={filterType || "Select type"}
              options={dummyFilterType}
              onSelect={option => {
                setFilterType(option);
              }}
            />
          </div>
        </div>
      </div>

      <div className="overflow-y-auto h-[calc(100vh-150px)]">
        <div className="m-auto w-[1150px]">
          <TrendCurvesGraph
            lineGraphData={trendsCurveData}
            width={1150}
            trendsCurveExpandedView={true}
          />
        </div>

        <TrendTable trendsCurveRawData={trendsCurveRawData} />
      </div>
    </div>
  );
};

export default ExpandViewSnapshotTrendCurveAnalysis;
